import React from 'react';
import { Link } from 'react-router-dom';
import { 
  CONTACT_EMAIL,
  CONTACT_ADDRESS,
  CONTACT_MOBILE
} from '../../config';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      {/* Footer Start */}
      <div className="container-fluid bg-dark text-white-50 footer pt-5 mt-5">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-secondary mb-4">Contact Info</h4>
                <Link to={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT_ADDRESS)}`} target="_blank" rel="noreferrer">
                  <i className="fa fa-map-marker-alt me-2"></i>{CONTACT_ADDRESS}
                </Link>
                <Link to={`mailto:${CONTACT_EMAIL}`}>
                  <i className="fas fa-envelope me-2"></i>{CONTACT_EMAIL}
                </Link>
                <Link to={`tel:${CONTACT_MOBILE}`}>
                  <i className="fas fa-phone me-2"></i> {CONTACT_MOBILE}
                </Link>
                {/* <div className="d-flex align-items-center">
                  <i className="fas fa-share fa-2x text-secondary me-2"></i>
                  <Link className="btn mx-1" to=""><i className="fab fa-facebook-f"></i></Link>
                  <Link className="btn mx-1" to=""><i className="fab fa-twitter"></i></Link>
                  <Link className="btn mx-1" to=""><i className="fab fa-instagram"></i></Link>
                  <Link className="btn mx-1" to=""><i className="fab fa-linkedin-in"></i></Link>
                </div> */}
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-secondary mb-4">Opening Time</h4>
                <div className="mb-3">
                  <h6 className="text-muted mb-0">Mon - Friday:</h6>
                  <p className="text-white mb-0">10.00 am to 05.00 pm</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-secondary mb-4">Our Services</h4>
                <Link to="/immigration" className=""><i className="fas fa-angle-right me-2"></i>Immigration</Link>
                <Link to="/business-setup" className=""><i className="fas fa-angle-right me-2"></i>Business Setup</Link>
                <Link to="/business-support" className=""><i className="fas fa-angle-right me-2"></i>Business Support</Link>
              </div>
            </div>
            {/* <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item">
                <h4 className="text-secondary mb-4">Newsletter</h4>
                <p className="text-white mb-3">Dolor amet sit justo amet elitr clita ipsum elitr est.Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                <div className="position-relative mx-auto rounded-pill">
                  <input className="form-control border-0 rounded-pill w-100 py-3 ps-4 pe-5" type="text" placeholder="Enter your email" />
                  <button type="button" className="btn btn-primary rounded-pill position-absolute top-0 end-0 py-2 mt-2 me-2">SignUp</button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* Footer End */}

      {/* Copyright Start */}
      <div className="container-fluid copyright py-4">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
                <span className="text-white">
                  <i className="fas fa-copyright text-light me-2"></i>{currentYear} The Trivedi Solutions, All rights reserved.
                </span>
            </div>
            <div className="col-md-6 text-center text-md-end text-white">
              {/* Designed By <Link className="border-bottom text-white" to="">Aarohi</Link> */}
            </div>
          </div>
        </div>
      </div>
      {/* Copyright End */}

      {/* Back to Top */}
      <button type="button" className="btn btn-primary btn-lg-square back-to-top" aria-label="back to top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <i className="fa fa-arrow-up"></i>
      </button>
    </>
  );
};

export default Footer; 